export const HIGHLIGHT_LAYER_ATTR = "data-highlight-text-layer";
export const HIGHLIGHT_PAGE_ATTR = "data-highlight-text-page";
